var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoChargeFilterSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    xmlSpace: "preserve",
    id: "evio_filter_selectedCanvas",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient24bezier3bezier3go_charge_occupied_origCanvasbezier3go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3",
    x1: 38.64,
    y1: 7.02,
    x2: 28.64,
    y2: 17.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "rgb(66, 86, 105)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "rgb(79, 121, 162)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "rgb(87, 144, 197)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient26bezier5bezier5go_charge_occupied_origCanvasbezier5go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5",
    x1: 42.15,
    y1: 13.76,
    x2: 32.15,
    y2: 23.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "rgb(86, 142, 195)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "rgb(77, 116, 153)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "rgb(61, 74, 86)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient29bezier7bezier9go_charge_occupied_origCanvasbezier7go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7",
    x1: 37.91,
    y1: 20.88,
    x2: 27.91,
    y2: 30.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient29bezier7bezier9go_charge_occupied_origCanvasbezier7go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9",
    x1: 29.33,
    y1: 21.45,
    x2: 19.33,
    y2: 31.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient32bezier11bezier11go_charge_occupied_origCanvasbezier11go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11",
    x1: 23.75,
    y1: 14.7,
    x2: 13.75,
    y2: 24.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "rgb(85, 138, 189)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "rgb(72, 104, 133)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient33bezier12bezier12go_charge_occupied_origCanvasbezier12go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12",
    x1: 28.35,
    y1: 6.08,
    x2: 18.35,
    y2: 16.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(54, 54, 54)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "rgb(59, 68, 76)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "rgb(72, 104, 134)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "rgb(82, 130, 176)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "rgb(88, 146, 201)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(90, 152, 211)",
    stopOpacity: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "evio_filter_selectedCanvas-rectangle",
    stroke: "none",
    fill: "rgb(241, 245, 255)",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgroup2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier",
    stroke: "none",
    fill: "rgb(54, 54, 54)",
    d: "M 44,18.91 C 44,10.12 36.84,3 28,3 19.16,3 12,10.12 12,18.91 12,21.88 12.82,24.66 14.25,27.04 L 14.24,27.04 28,53 41.76,27.04 41.75,27.04 C 43.18,24.66 44,21.88 44,18.91 Z M 44,18.91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier2",
    stroke: "none",
    fill: "none",
    d: "M 28.22,8.69 L 28.22,8.69 28.22,8.69 Z M 28.22,8.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient24bezier3bezier3go_charge_occupied_origCanvasbezier3go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3)",
    d: "M 29.3,9.98 C 32.89,10.52 35.77,13.18 36.6,16.62 37.42,16.33 38.25,16.05 39.07,15.77 37.92,11.45 34.26,8.12 29.71,7.44 28.94,7.32 28.23,7.91 28.22,8.69 L 28.22,8.69 C 28.21,9.33 28.67,9.89 29.3,9.98 Z M 29.3,9.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier4",
    stroke: "none",
    fill: "none",
    d: "M 36.54,13.41 L 36.54,13.41 36.54,13.41 Z M 36.54,13.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient26bezier5bezier5go_charge_occupied_origCanvasbezier5go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5)",
    d: "M 36.06,23.56 C 35.84,22.88 36.2,21.99 37.14,21.99 38.34,21.99 38.59,23.44 37.9,24.06 37.92,24.13 37.94,24.19 37.95,24.26 39.71,21.16 39.97,17.33 38.42,13.96 38.09,13.25 37.21,12.99 36.54,13.41 L 36.54,13.41 C 36,13.75 35.77,14.44 36.04,15.02 37.46,18.08 36.95,21.64 34.86,24.19 34.95,24.18 35.03,24.17 35.12,24.17 35.35,24.17 35.53,24.22 35.69,24.3 35.72,24.02 35.85,23.75 36.06,23.56 Z M 36.06,23.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier6",
    stroke: "none",
    fill: "none",
    d: "M 37.54,21.84 L 37.54,21.84 37.54,21.84 Z M 37.54,21.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient29bezier7bezier9go_charge_occupied_origCanvasbezier7go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7)",
    d: "M 35.96,22.48 C 34.38,25.71 30.95,27.63 27.4,27.39 27.43,28.26 27.45,29.12 27.47,29.98 31.97,30.19 36.28,27.73 38.29,23.63 38.64,22.93 38.28,22.09 37.53,21.84 L 37.53,21.84 C 36.92,21.64 36.25,21.9 35.96,22.48 Z M 35.96,22.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier8",
    stroke: "none",
    fill: "none",
    d: "M 30.5,28.3 L 30.5,28.3 30.5,28.3 Z M 30.5,28.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient29bezier7bezier9go_charge_occupied_origCanvasbezier7go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9)",
    d: "M 29.1,27.34 C 25.5,27.79 22.01,25.99 20.27,22.91 19.56,23.41 18.84,23.9 18.13,24.38 20.41,28.24 24.84,30.47 29.4,29.91 30.18,29.81 30.7,29.05 30.5,28.3 L 30.5,28.3 C 30.34,27.68 29.74,27.26 29.1,27.34 Z M 29.1,27.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier10",
    stroke: "none",
    fill: "none",
    d: "M 20.5,25.28 L 20.5,25.28 20.5,25.28 Z M 20.5,25.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient32bezier11bezier11go_charge_occupied_origCanvasbezier11go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11)",
    d: "M 20.71,23.61 C 18.9,21.01 18.69,17.67 20,14.9 19.95,14.88 19.89,14.86 19.84,14.83 19.74,15.3 19.37,15.7 18.73,15.7 17.7,15.7 17.37,14.63 17.74,13.93 17.71,13.89 17.68,13.84 17.65,13.79 15.95,17.37 16.22,21.68 18.56,25.06 19,25.7 19.92,25.8 20.5,25.28 L 20.5,25.28 C 20.98,24.85 21.08,24.14 20.71,23.61 Z M 20.71,23.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12",
    stroke: "none",
    fill: "url(#evio_filter_selectedCanvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgo_charge_offlineCanvasgradient33bezier12bezier12go_charge_occupied_origCanvasbezier12go_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12)",
    d: "M 28.09,6.1 L 28.04,6.1 C 27.34,6.1 26.77,6.66 26.77,7.35 22.68,7.79 19.04,10.41 17.43,14.29 17.12,15.01 17.54,15.83 18.3,16.03 L 18.3,16.03 C 18.92,16.19 19.58,15.88 19.83,15.29 21.03,12.38 23.72,10.38 26.77,9.95 L 26.77,13.94 C 26.77,14.63 27.34,15.2 28.04,15.2 L 28.1,15.2 C 28.8,15.2 29.37,14.63 29.37,13.94 L 29.37,7.36 C 29.37,6.66 28.79,6.1 28.09,6.1 Z M 28.09,6.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoChargeFilterSelected);
export default __webpack_public_path__ + "static/media/go_charge_filter_selected.88681a6f7c6671640398115ebd883516.svg";
export { ForwardRef as ReactComponent };